import { useContext, useRef, useEffect, useState } from "react";
import { AppContext } from "../Context";

function ParamFabric() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [buttons, setButtons] = useState([]);
    const [fabricCategory, setFabricCategory] = useState(state.fabricCategory);
    const [items, setItems] = useState([]);
    const param = useRef(null);
    const list = useRef(null);
    const catData = useRef({});

    useEffect(() => {
        const btns = state.fabricData.map((item, index) => ({
            id: item.id,
            caption: item.caption,
            price: item.price,
            active: index === 0
        }));
        setButtons(btns);
    }, []);

    useEffect(() => {
        const selected = state.fabricData.find((obj) => obj.id === fabricCategory);
        setItems(selected?.items || []);
        if (state.fabricData.length === 0) return;
    }, [state.fabricData]);

    function onTypeClick(id, title, p) {
        setFabricCategory(id);
        catData.current = { category: id, title: title, price: p };
        const selected = state.fabricData.find((obj) => obj.id === id);
        setItems(selected?.items || []);
    }
    function onItemClick(pattern, tex, shirt, tile) {
        if (catData.current.category == undefined) {
            dispatch({ type: "SET_FABRIC_PRICE", payload: state.fabricPrice });
            dispatch({ type: "SET_FABRIC_CATEGORY", payload: state.fabricCategory });
            dispatch({ type: "SET_FABRIC_CATEGORY_TITLE", payload: state.fabricCategoryTitle });
        } else {
            dispatch({ type: "SET_FABRIC_PRICE", payload: catData.current.price });
            dispatch({ type: "SET_FABRIC_CATEGORY", payload: catData.current.category });
            dispatch({ type: "SET_FABRIC_CATEGORY_TITLE", payload: catData.current.title });
        }
        dispatch({ type: "SET_FABRIC_PATTERN", payload: pattern });
        dispatch({ type: "SET_FABRIC_SHIRT", payload: shirt });
        dispatch({ type: "SET_FABRIC_TEXTURE", payload: tex });
        dispatch({ type: "SET_FABRIC_TILE", payload: tile });

        dispatch({ type: "SET_DONE", payload: true });
    }
    return (
        <div ref={param} className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Fabric</div>
                <div className="btnBox">
                    {buttons.map((btn, index) => (
                        <div
                            onClick={() => { onTypeClick(btn.id, btn.caption, btn.price) }}
                            className={`paramButtons ${fabricCategory === btn.id ? "active" : ""}`}
                            key={index}
                        >{btn.caption}</div>
                    ))}
                </div>
            </div>
            <div ref={list} className="monoList">
                {items.map((item, index) => (
                    <div key={index}>
                        <img onClick={() => { onItemClick(item.pattern, item.tex, item.shirt, item.tile) }} className="fabricImg" src={`${process.env.PUBLIC_URL}/fabrics/${fabricCategory}/${item.tile}`} width={80} />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamFabric